// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.access-dialog-modal {
  display: grid;
  place-items: center;
  padding: var(--space-4, 16px);
}
.access-dialog-backdrop {
  background: var(--overlay-scrim, rgba(20, 38, 36, 0.52)) !important;
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
}
.access-dialog {
  width: min(440px, calc(100vw - 32px));
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  outline: 0;
  background: var(--surface-primary, #fff);
  box-shadow: var(--elevation-xl, 0 24px 48px -12px rgba(14, 26, 32, 0.24));
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.access-dialog-header {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 32px;
  align-items: center;
  gap: var(--space-3, 12px);
  padding: var(--space-5, 20px) var(--space-6, 24px);
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.access-dialog-icon {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: var(--radius-full, 9999px);
  background: var(--warning-soft, #fff7e6);
  color: var(--warning-text, #9a6700);
}
.access-dialog-icon svg {
  width: 20px;
  height: 20px;
}
.access-dialog h2 {
  margin: 0;
  font-size: 18px;
  font-weight: var(--font-weight-semibold, 600);
  line-height: 1.4;
  letter-spacing: -0.18px;
}
.access-dialog-close {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.access-dialog-close:hover {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}
.access-dialog-content {
  padding: var(--space-6, 24px);
}
.access-dialog-content p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 1.55;
}
.access-dialog-actions {
  display: flex;
  justify-content: flex-end;
  padding: var(--space-4, 16px) var(--space-6, 24px);
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.access-dialog-actions button {
  min-height: var(--control-md, 40px);
  padding: 0 var(--space-4, 16px);
  border: 1px solid var(--interactive-default, #0f766e);
  border-radius: var(--radius-md, 10px);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
  font: var(--font-weight-medium, 500) 13px/1
    var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.access-dialog-close:focus-visible,
.access-dialog-actions button:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 2px;
}
@media (max-width: 600px) {
  .access-dialog-header,
  .access-dialog-content,
  .access-dialog-actions {
    padding-right: var(--space-5, 20px);
    padding-left: var(--space-5, 20px);
  }
  .access-dialog-actions button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/appModel/appmodal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,mEAAmE;EACnE,kCAA0B;UAA1B,0BAA0B;AAC5B;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,UAAU;EACV,wCAAwC;EACxC,yEAAyE;EACzE,mCAAmC;EACnC,6DAA6D;AAC/D;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kDAAkD;EAClD,mDAAmD;AACrD;AACA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,qDAAqD;EACrD,qCAAqC;EACrC,+CAA+C;EAC/C,0CAA0C;EAC1C;oDACkD;EAClD,eAAe;AACjB;AACA;;EAEE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE;;;IAGE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".access-dialog-modal {\n  display: grid;\n  place-items: center;\n  padding: var(--space-4, 16px);\n}\n.access-dialog-backdrop {\n  background: var(--overlay-scrim, rgba(20, 38, 36, 0.52)) !important;\n  backdrop-filter: blur(3px);\n}\n.access-dialog {\n  width: min(440px, calc(100vw - 32px));\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  outline: 0;\n  background: var(--surface-primary, #fff);\n  box-shadow: var(--elevation-xl, 0 24px 48px -12px rgba(14, 26, 32, 0.24));\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.access-dialog-header {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr) 32px;\n  align-items: center;\n  gap: var(--space-3, 12px);\n  padding: var(--space-5, 20px) var(--space-6, 24px);\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.access-dialog-icon {\n  display: grid;\n  width: 36px;\n  height: 36px;\n  place-items: center;\n  border-radius: var(--radius-full, 9999px);\n  background: var(--warning-soft, #fff7e6);\n  color: var(--warning-text, #9a6700);\n}\n.access-dialog-icon svg {\n  width: 20px;\n  height: 20px;\n}\n.access-dialog h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: 1.4;\n  letter-spacing: -0.18px;\n}\n.access-dialog-close {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  padding: 0;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.access-dialog-close:hover {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n.access-dialog-content {\n  padding: var(--space-6, 24px);\n}\n.access-dialog-content p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 1.55;\n}\n.access-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding: var(--space-4, 16px) var(--space-6, 24px);\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.access-dialog-actions button {\n  min-height: var(--control-md, 40px);\n  padding: 0 var(--space-4, 16px);\n  border: 1px solid var(--interactive-default, #0f766e);\n  border-radius: var(--radius-md, 10px);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n  font: var(--font-weight-medium, 500) 13px/1\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.access-dialog-close:focus-visible,\n.access-dialog-actions button:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 2px;\n}\n@media (max-width: 600px) {\n  .access-dialog-header,\n  .access-dialog-content,\n  .access-dialog-actions {\n    padding-right: var(--space-5, 20px);\n    padding-left: var(--space-5, 20px);\n  }\n  .access-dialog-actions button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
